import { createContext, useContext } from "react";
import type { TesterTrial } from "@shared/testerCampaign";
import type { TesterTaskId } from "./testerTasks";
export interface TesterState {
  trial: TesterTrial | null;
  welcomePending: boolean;
  consentDecided: boolean;
  completed: string[];
  finishWelcome: (recording: boolean) => void;
  complete: (task: TesterTaskId) => void;
}
export const TesterContext = createContext<TesterState | undefined>(undefined);
export const useTester = () => useContext(TesterContext);
